import React from "react";
import { AntdDefaultButton } from "./styles";

export default function DefaultButton({ ...props }) {
	return <AntdDefaultButton {...props} />;
}
